import {useState } from "react";
import {
  ContainerEstra,
  CustomPiramide,
  LevelButton,
  LevelDetail,
} from "./piramide.styled";

import nivel1 from "../../../assets/img/nivel_1.svg";
import nivel21 from "../../../assets/img/nivel_2_1.svg";
import nivel22 from "../../../assets/img/nivel_2_2.svg";
import nivel3 from "../../../assets/img/nivel_3.svg";

const BCPiramide = () => {
  const [viewNivel1, setnViewNivel1] = useState(false);
  const [viewNivel21, setnViewNivel21] = useState(false);
  const [viewNivel22, setnViewNivel22] = useState(false);
  const [viewNivel3, setnViewNivel3] = useState(false);

  return (
    <ContainerEstra>
      <h1>Elegir estratégicamente qué queremos que recuerden</h1>
      <CustomPiramide>
        <div className="piramide">
          <LevelButton
            onClick={() => setnViewNivel1(!viewNivel1)}
            className="level-1"
            type="button"
            title="nivel1"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <img src={nivel1} alt="nivel1" />
            <span>
              {viewNivel1
                ? "Grandes apuestas: Memorables, perdurables, significativas "
                : "Nivel 1"}
            </span>
            {viewNivel1 && (
              <LevelDetail
                className="level-1"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <strong>Nivel 1:</strong> <br /> Focos que apuntan a la
                diferenciación y significancia. Denotan innovación, conexión
                emocional y espíritu emprendedor. Movidas estratégicas no
                necesariamente rentables en el hoy.{" "}
              </LevelDetail>
            )}
          </LevelButton>
          <LevelButton
          onClick={() => setnViewNivel21(!viewNivel21)}
            className="level-21"
            type="button"
            title="nivel21"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <img src={nivel21} alt="nivel21" />
            <span>
              {viewNivel21
                ? "Movilizadores de negocio, generadores de rentabilidad: Altamente competidos"
                : "Nivel 2.1"}
            </span>
            {viewNivel21 && (
              <LevelDetail
                className="level-21"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <strong>Nivel 2.1:</strong> <br /> Focos que movilizan los objetivos de negocio y son altamente competidos o en otro extremo muy diferenciales.{" "}
              </LevelDetail>
            )}
          </LevelButton>
          <LevelButton
            onClick={() => setnViewNivel22(!viewNivel22)}
            className="level-22"
            type="button"
            title="nivel22"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <img src={nivel22} alt="nivel22" />
            <span>
              {viewNivel22
                ? "Medianamente competidos"
                : "Nivel 2.2"}
            </span>
            {viewNivel22 && (
              <LevelDetail
                className="level-22"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <strong>Nivel 2.2:</strong> <br />Focos que movilizan los objetivos de negocio y son medianamente competidos, no diferenciales.{" "}
              </LevelDetail>
            )}
          </LevelButton>
          <LevelButton
          onClick={() => setnViewNivel3(!viewNivel3)}
            className="level-3"
            type="button"
            title="nivel3"
            data-aos="fade-up"
            data-aos-duration="2500"
          >
            <img src={nivel3} alt="nivel3" />
            <span>
              {viewNivel3
                ? "Base del negocio. Indispensables para la facturación y recurrencia"
                : "Nivel 3"}
            </span>
            {viewNivel3 && (
              <LevelDetail
                className="level-3"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <strong>Nivel 3:</strong> <br />Focos que son la base del negocio actual. No representan el grueso del ingreso o no requieren demasiado esfuerzo en su consecución.{" "}
              </LevelDetail>
            )}
          </LevelButton>
        </div>
      </CustomPiramide>
    </ContainerEstra>
  );
};

export default BCPiramide;
